import { useEffect, useState } from 'react';

// Utilidades de movimiento compartidas por la landing.

// Se consulta en el momento de usarla: el usuario puede cambiar la preferencia
// del sistema sin recargar.
export const prefiereQuieto = () =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const easeOutQuart = (t) => 1 - Math.pow(1 - t, 4);

// Anima el texto de un nodo de un número a otro (solo cambia el contenido de
// texto: no mueve el layout si el ancho es tabular). Devuelve una función que
// cancela la animación. `formato` convierte el número a texto.
export function contar(el, desde, hasta, { delay = 0, duracion = 800, formato = String } = {}) {
  if (!el) return () => {};
  let raf = 0;
  let timer = 0;
  let cancelado = false;
  const escribir = (n) => { el.textContent = formato(n); };
  escribir(desde);
  timer = setTimeout(() => {
    const t0 = performance.now();
    const paso = (ahora) => {
      if (cancelado) return;
      const t = Math.min(1, (ahora - t0) / duracion);
      escribir(Math.round(desde + (hasta - desde) * easeOutQuart(t)));
      if (t < 1) raf = requestAnimationFrame(paso);
    };
    raf = requestAnimationFrame(paso);
  }, delay);
  return () => { cancelado = true; clearTimeout(timer); cancelAnimationFrame(raf); };
}

// true la primera vez que el elemento entra en pantalla (y se queda en true).
// Con reduced-motion o sin IntersectionObserver arranca en true.
export function useEnVista(ref, umbral = 0.6) {
  const [visto, setVisto] = useState(() => prefiereQuieto() || typeof IntersectionObserver === 'undefined');
  useEffect(() => {
    if (visto) return;
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { setVisto(true); obs.disconnect(); }
    }, { threshold: umbral });
    obs.observe(el);
    return () => obs.disconnect();
  }, [visto, ref, umbral]);
  return visto;
}
